export default __webpack_public_path__ + "static/media/image.6a546f7f.jpg";